import { Component, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { ExperienceNotificationThrottlingMetrics } from '@app/core/models/notification-throttling';
import { Chart, ChartConfiguration } from 'chart.js/auto';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  standalone: true,
})
export class BarChartComponent implements AfterViewInit, OnDestroy {
  @Input() id: string = 'bar-chart';
  @Input() metrics: ExperienceNotificationThrottlingMetrics | null = null;
  private chart?: Chart;

  ngAfterViewInit(): void {
    if (this.metrics && this.metrics.notificationStatus) {
      this.chart = new Chart('barChart' + this.id, {
        type: 'bar',
        data: {
          labels: [
            ...Object.values(this.metrics.notificationStatus).map(
              (ns) => ns.timeBucket,
            ),
          ],
          datasets: [
            {
              label: 'Attempted',
              data: [
                ...Object.values(this.metrics.notificationStatus).map(
                  (ns) => ns.attempted,
                ),
              ],
              backgroundColor: 'rgba(70,130,180,0.6)',
              stack: 'stack1',
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
            tooltip: {
              mode: 'index', // show all datasets for that index (time bucket)
              intersect: false, // trigger tooltip when hovering anywhere in that group
              displayColors: false, // don't show color boxes in tooltip
              titleAlign: 'center',
              callbacks: {
                title: (context) => '',
                label: (context) => {
                  const label = context.dataset.label;
                  const value = context.parsed.y;
                  if (label === 'Attempted') {
                    return `${value} sent`;
                  }
                  return `${value}`;
                },
              },
            },
          },
          scales: {
            x: {
              stacked: true,
              grid: { display: false },
              ticks: {
                padding: -2,

                font: (context) => {
                  const width = context.chart.width;
                  let size = 10;
                  if (width < 300) size = 5;
                  else if (width < 400) size = 7;
                  else if (width < 800) size = 10;
                  else size = 9;
                  return { size };
                },
              },
              border: { display: false },
            },
            y: {
              stacked: true,
              beginAtZero: true,
              grid: { display: false },
              ticks: { stepSize: 2, display: false },
              border: { display: false },
            },
          },
          datasets: {
            bar: {
              categoryPercentage: 0.9,
              barPercentage: 0.9,
              borderSkipped: false,
              borderWidth: 0,
            },
          },
        } as ChartConfiguration['options'],
      });
    }
  }

  ngOnDestroy(): void {
    // Destroy chart to prevent memory leaks
    this.chart?.destroy();
  }
}
